class FreeShippingMeter extends HTMLElement {
  constructor() {
    super();
  }

  static freeShippingTagText = "Free Shipping for Every Purchase of<br>Balancing Cleansing Oil";
  static freeShippingText  = window.free_shipping_text.free_shipping_message;
  static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
  static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
  static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
  static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
  static classLabel1 = 'progress-30';
  static classLabel2 = 'progress-60';
  static classLabel3 = 'progress-100';
  static freeshipPrice = parseInt(window.free_shipping_price);

  // NEW: any product with this tag unlocks free shipping
  static freeShipTags = ['freeshipping'];

  connectedCallback() {
    this.freeShippingEligible = 0;
    this.progressBar = this.querySelector('[data-shipping-progress]');
    this.messageElement = this.querySelector('[data-shipping-message]');
    this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
    this.shipVal = window.free_shipping_text.free_shipping_1;

    // FIX: remove leading space in selector
    this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');

    this.addEventListener('change', this.onCartChange.bind(this));
    this.initialize();
  }

  initialize() {
    Shopify.getCart((cart) => {
      this.cart = cart;
      this.calculateProgress(cart);
    });
  }

  onCartChange(e) {
    this.initialize();
  }

  // NEW helpers
  normalizeTags(tags) {
    if (!tags) return [];
    if (Array.isArray(tags)) return tags.map(t => String(t).toLowerCase().trim());
    return String(tags).toLowerCase().split(',').map(t => t.trim());
  }

  // Try to detect the tag from cart items; if missing, fall back to fetching product JSON
  async hasFreeShippingOverride(cart) {
    const wanted = FreeShippingMeter.freeShipTags;
    if (!wanted?.length) return false;

    const items = cart?.items || [];

    // Pass 1: tags present on line items?
    for (const it of items) {
      const present = this.normalizeTags(it?.product?.tags || it?.tags || it?.product_tags);
      if (present.length && wanted.some(tag => present.includes(tag))) return true;
    }

    // Pass 2: fetch product JSON by handle/url to read tags
    const checks = items.map(async (it) => {
      try {
        const handle = it?.handle || (it?.url ? it.url.replace(/^.*\/products\//,'').replace(/\/.*$/,'') : null);
        if (!handle) return false;
        const res = await fetch(`/products/${handle}.js`, { headers: { 'Accept':'application/json' } });
        if (!res.ok) return false;
        const product = await res.json();
        const present = this.normalizeTags(product?.tags || []);
        return wanted.some(tag => present.includes(tag));
      } catch { return false; }
    });

    const results = await Promise.all(checks);
    return results.some(Boolean);
  }

  calculateProgress(cart) {
    let totalPrice = cart.total_price;

    if ($('body').hasClass('setup_shipping_delivery')) {
      const giftCardItems = $(".cart-item[data-price-gift-card], .previewCartItem[data-price-gift-card]");
      if (giftCardItems.length > 0) {
        giftCardItems.each(function() {
          totalPrice -= parseFloat($(this).attr("data-price-gift-card"));
        });
      }
    }

    // NEW: check override first (async), then continue with your normal math
    this.hasFreeShippingOverride(cart).then((override) => {
      if (override) {
        // force visible, full bar, success message
        this.progressBar?.classList.remove('progress-hidden');
        this.setProgressWidthAndText(100, FreeShippingMeter.freeShippingTagText, 'progress-free');
        return;
      }

      // — original calculation —
      const cartTotalPrice = parseInt(totalPrice) / 100;
      const cartTotalPriceFormatted = cartTotalPrice.toFixed(2);
      const cartTotalPriceRounded = parseFloat(cartTotalPriceFormatted);

      let freeShipBar = Math.abs((cartTotalPriceRounded * 100) / FreeShippingMeter.freeshipPrice);
      if (freeShipBar >= 100) {
        freeShipBar = 100;
      }

      const text = this.getText(cartTotalPriceFormatted, freeShipBar);
      const classLabel = this.getClassLabel(freeShipBar);

      this.setProgressWidthAndText(freeShipBar, text, classLabel);
    });
  }

  getText(cartTotalPrice, freeShipBar) {
    let text;

    if (cartTotalPrice == 0) {
      this.progressBar.classList.add('progress-hidden');
      text = '<span>' + FreeShippingMeter.freeShippingText + ' ' + Shopify.formatMoney(FreeShippingMeter.freeshipPrice * 100, window.money_format) +'!</span>';
    } else if (cartTotalPrice >= FreeShippingMeter.freeshipPrice) {
      this.progressBar.classList.remove('progress-hidden');
      this.freeShippingEligible = 1;
      text = FreeShippingMeter.freeShippingText1;
    } else {
      this.progressBar.classList.remove('progress-hidden');
      const remainingPrice = Math.abs(FreeShippingMeter.freeshipPrice - cartTotalPrice);
      text = '<span>' + FreeShippingMeter.freeShippingText2 + ' </span>' + Shopify.formatMoney(remainingPrice * 100, window.money_format) + '<span> ' +  FreeShippingMeter.freeShippingText3 + ' </span><span class="text">' + FreeShippingMeter.freeShippingText4 + '</span>';
      this.shipVal = window.free_shipping_text.free_shipping_2;
    }

    return text;
  }

  getClassLabel(freeShipBar) {
    let classLabel;

    if (freeShipBar === 0) {
      classLabel = 'none';
    } else if (freeShipBar <= 30) {
      classLabel = FreeShippingMeter.classLabel1;
    } else if (freeShipBar <= 60) {
      classLabel = FreeShippingMeter.classLabel2;
    } else if (freeShipBar < 100) {
      classLabel = FreeShippingMeter.classLabel3;
    } else {
      classLabel = 'progress-free';
    }

    return classLabel;
  }

  resetProgressClass(classLabel) {
    this.progressBar.classList.remove('progress-30', 'progress-60', 'progress-100', 'progress-free');
    this.progressBar.classList.add(classLabel);
  }

  setProgressWidthAndText(freeShipBar, text, classLabel) {
    setTimeout(() => {
      this.resetProgressClass(classLabel);

      this.progressMeter.style.width = `${freeShipBar}%`;
      if (this.textEnabled) {
        const textWrapper = this.progressMeter.querySelector('.text');
        if (textWrapper) textWrapper.innerHTML = `${freeShipBar.toFixed(2)}%`;
      }

      this.messageElement.innerHTML = text;

      if ($('.dropdown-item[data-currency]').length) {
        if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
          Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
        }
      }
    }, 400);
  }
}

window.addEventListener('load', () => {
  if (!customElements.get('free-shipping-component')) {
    customElements.define('free-shipping-component', FreeShippingMeter);
  }
});
